export enum TipoReporteBalance7 {
    Contenedor15 = 0,
    ContenedorNatural = 1
}